import { inject, Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { RouteCustomData } from '../models/route-custom-data';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);

  public customData: Record<string, any> = {};

  getCustomRouteData(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => {
        let child: ActivatedRoute | null = this.route.firstChild;
        while (child) {
          if (child.firstChild) {
            child = child.firstChild;
          } else if (child.snapshot.data) {
            return child.snapshot.data;
          } else {
            return null;
          }
        }
        return null;
      }),
      filter((data): data is RouteCustomData => !!data),
    ).subscribe((data: RouteCustomData) => {
      this.customData = data;
    });
  }
}
